<!-- eslint-disable i18next/no-literal-string -->
<template>
  <b-row>
    <b-col cols="6">
      <div class="h1 text-center font-weight-bold">Default Type</div>
      <!-- SIMPLE TAB -->
      <div class="h3 font-weight-bold">Simple tab</div>
      <b-card no-body>
        <McTabs :items="remapItems" :options="optionsDefault" />
      </b-card>

      <!-- CUSTOM TAB ITEM -->
      <div class="h3 font-weight-bold">Custom tab</div>
      <b-card no-body>
        <mc-tabs :options="optionsDefault">
          <mc-tab title="Tab 1" active>
            <b-img src="https://picsum.photos/1024/400/?image=41" width="200" fluid alt="Responsive image"></b-img>
          </mc-tab>
          <mc-tab title="Tab 2">
            <b-row>
              <b-col cols="6">Kiri</b-col>
              <b-col cols="6">Kanan</b-col>
            </b-row>
          </mc-tab>
          <mc-tab title="Tab 2">
            <template #title>
              <i class="fa fa-home" /> I'm <i>custom</i> <strong>title</strong>
            </template>
            <div class="p-3">Custom content</div>
          </mc-tab>
          <mc-tab title="Tab 4" disabled>
            <div class="p-3">Custom content</div>
          </mc-tab>
        </mc-tabs>
      </b-card>

      <div class="h3 font-weight-bold">Slot to customize content</div>
      <b-card no-body>
        <mc-tabs :items="remapItems" :options="optionsDefault">
          <template #default="{ items }">
            <mc-tab
              v-for="(val, key) in items"
              :title="val.title"
              :active="val.active"
              :key="key"
              :disabled="val?.attributes?.disabled"
            >
              <b-img src="https://picsum.photos/1024/400/?image=41" width="200" fluid alt="Responsive image"></b-img>
              <div class="mt-2">{{ val.content }}</div>
            </mc-tab>
          </template>
        </mc-tabs>
      </b-card>
    </b-col>
    <b-col cols="6">
      <div class="h1 text-center font-weight-bold">Pills Type</div>
      <!-- SIMPLE TAB -->
      <div class="h3 font-weight-bold">Simple tab</div>
      <b-card no-body>
        <McTabs :items="remapItems" :options="optionsPill" />
      </b-card>

      <!-- CUSTOM TAB ITEM -->
      <div class="h3 font-weight-bold">Custom tab</div>
      <b-card no-body>
        <mc-tabs :options="optionsPill">
          <mc-tab title="Tab 1" active>
            <b-img src="https://picsum.photos/1024/400/?image=41" width="200" fluid alt="Responsive image"></b-img>
          </mc-tab>
          <mc-tab title="Tab 2">
            <b-row>
              <b-col cols="6">Kiri</b-col>
              <b-col cols="6">Kanan</b-col>
            </b-row>
          </mc-tab>
          <mc-tab title="Tab 2">
            <template #title>
              <i class="fa fa-home" /> I'm <i>custom</i> <strong>title</strong>
            </template>
            <div class="p-3">Custom content</div>
          </mc-tab>
          <mc-tab title="Tab 4" disabled>
            <div class="p-3">Custom content</div>
          </mc-tab>
        </mc-tabs>
      </b-card>

      <div class="h3 font-weight-bold">Slot to customize content</div>
      <b-card no-body>
        <mc-tabs :items="remapItems" :options="optionsPill">
          <template #default="{ items }">
            <mc-tab
              v-for="(val, key) in items"
              :title="val.title"
              :active="val.active"
              :key="key"
              :disabled="val?.attributes?.disabled"
            >
              <b-img src="https://picsum.photos/1024/400/?image=41" width="200" fluid alt="Responsive image"></b-img>
              <div class="mt-2">{{ val.content }}</div>
            </mc-tab>
          </template>
        </mc-tabs>
      </b-card>
    </b-col>
    <b-col cols="6">
      <div class="h1 text-center font-weight-bold">Flats Type</div>

      <!-- SIMPLE TAB -->
      <div class="h3 font-weight-bold">Simple tab</div>
      <b-card no-body>
        <McTabs :items="remapItems" :options="{card: true, type: 'flats'}" />
      </b-card>
      
      <!-- CUSTOM TAB ITEM -->
      <div class="h3 font-weight-bold">Custom tab</div>
      <b-card no-body>
        <mc-tabs :value.sync="tabindex" :options="{ type: 'flats', card: true }">
          <mc-tab title="tab 1">
            <template #title>
              <i class="fa fa-home" /> I'm <i>custom</i>
            </template>
            content 1
          </mc-tab>
          <mc-tab title="Second">
            content 2
          </mc-tab>
          <mc-tab title="Third" disabled>
            content 3
          </mc-tab>
        </mc-tabs>
      </b-card>

      <div class="h3 font-weight-bold">Slot to customize content</div>
      <b-card no-body>
        <mc-tabs :items="remapItems" :options="optionsFlat">
          <template #default="{ items }">
            <mc-tab
              v-for="(val, key) in items"
              :title="val.title"
              :active="val.active"
              :key="key"
              :disabled="val?.attributes?.disabled"
            >
              <b-img src="https://picsum.photos/1024/400/?image=41" width="200" fluid alt="Responsive image"></b-img>
              <div class="mt-2">{{ val.content }}</div>
            </mc-tab>
          </template>
        </mc-tabs>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
import McTabs from './index'
import McTab from './McTab'
export default {
  components: {
    McTabs,
    McTab
  },
  props: ['propsData'],
  data() {
    return {
      tabindex: 1,
      items: [
        {
          title: 'First',
          content: 'Content 1'
        },
        {
          title: 'Second',
          content: 'Content 2',
          active: true
        },
        {
          title: 'Third',
          content: 'Content 3',
          attributes: {
            disabled: true
          }
        }
      ],
      optionsPill: {
        type: 'pills',
        card: true
      },
      optionsDefault: {
        card: true,
        // 'content-class': 'mt-3 ps-3'
      },
      optionsFlat: {
        type: 'flats',
        card: true
      }
    }
  },
  computed: {
    props() {
      return this.propsData
    },
    active() {
      return this.props?.activetab
    },
    remapItems() {
      if (!Object.hasOwn(this.props, 'activetab')) return this.items
      return this.items.map((val, key) => {
        val.active = false
        if (key == this.props.activetab) {
          val.active = true
        }
        return val
      })
    }
  },
  created() {
    if (Object.hasOwn(this.props, 'activetab')) {
      this.tabindex = this.props.activetab
    }
  }
}
</script>